import React from "react";
import FormInput from "../../../../components/FormInput";
import styles from "../css/stockTransfer.module.css";
import Button from "../../../../components/Button";

export default function StockTransferDrugView({ selectedRow, isApproved, onAddToInventory }) {
  if (!selectedRow) return null;

  // Helper: format yyyy-mm-dd to dd/mm/yyyy for UI display only
  const formatDateDMY = (yyyyMmDd) => {
    const s = String(yyyyMmDd || '').trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return s;
    return `${m[3]}/${m[2]}/${m[1]}`;
  };

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Medication"
            type="text"
            name="medication"
            value={selectedRow?.drugName || ""}
            readOnly
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Branch"
            type="text"
            name="branch"
            value={selectedRow?.transferTo || ""}
            readOnly
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="SKU"
            type="text"
            name="sku"
            value={selectedRow?.sku || ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Nappi Code"
            type="text"
            name="nappi"
            value={selectedRow?.nappiCode || ""}
            onChange={() => {}}
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Strength"
            type="text"
            name="strength"
            value={selectedRow?.strength || ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Active Ingredient"
            type="text"
            name="ingredient"
            value={selectedRow?.activeIngredient || ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput label="Pack Size" type="text" name="packSize" value={"10s"} onChange={() => {}} />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Cost"
            type="text"
            name="cost"
            value={selectedRow?.costPrice != null ? selectedRow.costPrice.toString() : ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Expiry Date"
            type="text"
            name="expiry"
            value={formatDateDMY(selectedRow?.expiryDate || "")}
            readOnly
          />
        </div>
      </div>

      <hr className={styles.divider} />

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Date Requested"
            type="text"
            name="dateRequested"
            value={formatDateDMY(selectedRow?.requestDate || "")}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Requested By"
            type="text"
            name="requestedBy"
            value={selectedRow?.requestedByName || ""}
            onChange={() => {}}
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Note"
            type="text"
            name="note"
            value={selectedRow?.note || ""}
            onChange={() => {}}
          />
        </div>
      </div>

      <div className={styles.quantityRow}>
        <div className={styles.field}>
          <FormInput
            label="Quantity"
            type="text"
            name="quantity"
            value={selectedRow?.requestedQty?.toString?.() || ""}
            onChange={() => {}}
            className={styles.quantityNarrow}
          />
        </div>
        {isApproved && (
          <Button variant="primary" onClick={onAddToInventory} className={styles.addInventoryBtn}>
            Add to Inventory
          </Button>
        )}
      </div>
    </div>
  );
}
